import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { findIndex, map } from "lodash";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Modal from "@mui/material/Modal";
import { Grid } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import { getClassNames } from "../../Js/Common";
import Slide from "@mui/material/Slide";

import Rating from "@mui/material/Rating";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  "@media (min-width: 1636px)": {
    width: "28rem",
  },
  bgcolor: "#F5F7FF",
  border: "2px solid #FFFFFF",
  borderRadius: 10,
  p: 4,
};

const RatingModal = (props) => {
  let [timeoutObj, setTimeoutObj] = useState(null);
  let [initialRender, setInitialRender] = useState(true);
  let [selectedclass, setSelectedClass] = useState(null);
  let [rating, setRating] = useState(1);

  const classes = useStyles();

  useEffect(() => {
    if (props.timeout && props.visible) {
      setTimeoutObj(
        setTimeout(() => {
          props.toggleModal(false);
        }, props.timeout)
      );
    }
    if (!props.visible && timeoutObj) {
      clearTimeout(timeoutObj);
    }
    if (!initialRender && !props.visible && props.onClose) {
      props.onClose();
    }
  }, [props.visible]);

  useEffect(() => {
    setInitialRender(false);
  }, []);

  return (
    <div>
      <Modal
        open={props.visible}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ border: "0px !important" }}
      >
        <Box
          sx={{
            ...style,
            backgroundColor: "primary.main",
            border: 0,
            borderRadius: 6,
          }}
        >
          <Grid
            container
            sx={{
              flexDirection: "row",
              justifyContent: "center",
              alignContent: "center",
              alignItems: "center",
            }}
          >
            <Grid sx={{ textAlign: "center" }}>
              <Slide
                direction="up"
                timeout={500}
                in={true}
                mountOnEnter
                unmountOnExit
              >
                <img src={require('../../assets/thumbs_up.png')} className={classes.image} />
              </Slide>
            </Grid>
            <Grid sx={{ my: 1 }}>
              <Typography
                sx={{
                  textAlign: "center",
                  fontSize: "1rem",
                  fontWeight: "500",
                  color: "#FFFFFF",
                }}
              >
                Please rate your experience.
              </Typography>
            </Grid>
            <Grid>
              <Grid sx={{ my: 1 }}>
                <Rating
                  name="size-large"
                  defaultValue={1}
                  size=""
                  sx={{ fontSize: "2.4rem" }}
                  onChange={(event, newValue) => {
                    setRating(newValue);
                  }}
                />
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    borderRadius: 10,
                    backgroundColor: "#FFF",
                    color: "primary.main",
                    fontWeight: "bold",
                    mt: 3,
                    px: 2,
                    
                    "@media (min-width: 1636px)": {
                      width: "20rem",
                      fontSize: "1.4rem",
                    },
                  }}
                  onClick={() => {
                    props.done(rating);
                  }}
                >
                  Done
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
};

const useStyles = makeStyles({
  image: {
    width: "14rem",
    "@media (min-width: 1636px)": {
      width: "20rem",
    },
  },
});
export default RatingModal;
